import { render, staticRenderFns } from "./estatePrice.vue?vue&type=template&id=461749af&scoped=true&"
import script from "./estatePrice.vue?vue&type=script&lang=js&"
export * from "./estatePrice.vue?vue&type=script&lang=js&"
import style0 from "./estatePrice.vue?vue&type=style&index=0&id=461749af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461749af",
  null
  
)

export default component.exports